EMMY.entrantsLocked = {
  init: function () {
    EMMY.entrants.clickableListing();
    if($('#entryId').length > 0) {
        EMMY.entrants.entryId = document.getElementById('entryId').innerText;
        EMMY.entrants.ajaxBlurActiveSave = true;
        EMMY.entrants.ajaxBlurEntrant();
    }
  },
};
